var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 32,
    viewBox: "0 0 12 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3536 26.3536C11.5488 26.1583 11.5488 25.8417 11.3536 25.6464C11.1583 25.4512 10.8417 25.4512 10.6464 25.6464L11.3536 26.3536ZM5.99999 31L5.64643 31.3536C5.84169 31.5488 6.15828 31.5488 6.35354 31.3536L5.99999 31ZM1.35353 25.6464C1.15826 25.4512 0.841681 25.4512 0.646418 25.6464C0.451156 25.8417 0.451156 26.1583 0.646418 26.3536L1.35353 25.6464ZM6.49999 1C6.49999 0.723857 6.27613 0.5 5.99999 0.5C5.72384 0.5 5.49999 0.723857 5.49999 1L6.49999 1ZM10.6464 25.6464L5.64643 30.6465L6.35354 31.3536L11.3536 26.3536L10.6464 25.6464ZM6.35354 30.6465L1.35353 25.6464L0.646418 26.3536L5.64643 31.3536L6.35354 30.6465ZM6.49999 31L6.49999 1L5.49999 1L5.49999 31L6.49999 31Z",
    fill: "#FFCDEC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.cda022e324e5619064512d445ac96734.svg";
export { ForwardRef as ReactComponent };